import { render, staticRenderFns } from "./PanelPagination.vue?vue&type=template&id=af71a870&"
import script from "./PanelPagination.vue?vue&type=script&lang=js&"
export * from "./PanelPagination.vue?vue&type=script&lang=js&"
import style0 from "./PanelPagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports